import { jsx as m } from "react/jsx-runtime";
import f from "react";
import { omit as l } from "lodash";
const c = f.forwardRef(
  ({ children: t, testId: e, style: r, aria: a, tabIndex: o, className: s, ...d }, i) => /* @__PURE__ */ m(
    "div",
    {
      ref: i,
      "data-testid": e,
      className: s,
      tabIndex: o,
      ...a,
      style: {
        display: "flex",
        ...r,
        ...l(d, "className")
      },
      children: t
    }
  )
), u = f.forwardRef(
  ({ children: t, className: e, testId: r, aria: a, style: o, tabIndex: s, ...d }, i) => /* @__PURE__ */ m(
    "div",
    {
      ref: i,
      "data-testid": r,
      className: e,
      tabIndex: s,
      ...a,
      style: {
        ...o,
        ...l(d, "className")
      },
      children: t
    }
  )
);
export {
  c as FlexContainer,
  u as FlexItem
};
//# sourceMappingURL=index.es584.js.map
